export default async (callback = async () => {}) => {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        await callback();
    } else {
        document.addEventListener('DOMContentLoaded', callback);
    }
};
